<template>
  <v-col cols="12" md="md">
    <v-row>
      <v-col>
        <p><b>{{$t('common:settings')}}</b></p>
        <p>{{$t('common:date')}}: <b>{{ item.advert.dateStart }} - {{ item.advert.dateEnd }}</b></p>
        <p>{{$t('display/advert:statistic.regions')}}: <b>{{item.prettyRegions}}</b></p>
        <p>{{$t('common:tags')}}: <b>{{ tags() }}</b></p>
      </v-col>
      <v-col>
        <p><b>{{$t('common:budget')}}</b></p>
        <p>{{$t('common:budget')}}: <b>{{ budget() }}</b></p>
        <p>{{$t('display/advert:statistic.used-budget')}}: <b>{{ usedBudget() }}</b></p>
        <p>{{$t('display/advert:statistic.remaining-budget')}}: <b>{{ remainingBudget() }}</b></p>
        <p>{{$t('common:status')}}: <b>{{status()}}</b></p>
      </v-col>
      <v-col>
        <p><b>{{$t('display/advert:statistic.performance')}}</b></p>
        <p>{{$t('display/advert:statistic.plays-on-device')}}: <b>{{ item.advertStatistic.playsOnDevices }}</b></p>
        <p>{{$t('display/advert:statistic.blocked-on-devices')}}: <b>{{ item.advertStatistic.blockedOnDevices }}</b></p>
        <p>{{$t('display/advert:statistic.most-playouts-on')}}: <b>{{ item.advertStatistic.mostPlayed }}</b></p>
        <p>{{$t('display/advert:statistic.least-playouts-on')}}: <b>{{ item.advertStatistic.leastPlayed}}</b></p>
        <p>{{$t('display/advert:statistic.budget-finished')}}: <b>{{ budgetFinished() }}</b></p>
      </v-col>
    </v-row>

  </v-col>
</template>

<script>
import StatisticUtils from "@/modules/display/services/statistic-utils";

export default {
  name: "StatisticField",
  props: {
    item: Object,
    md: String
  },
  methods: {
    usedBudget() {
      return StatisticUtils.checkNullAndPrettifyNumber(this.item.advert.playedBudget);
    },
    budget() {
      return StatisticUtils.checkNullAndPrettifyNumber(this.item.advert.budget);
    },
    remainingBudget() {
      let remainingBudget = this.item.advert.budget - this.item.advert.playedBudget;
      return "€ " + remainingBudget < 0 ? '0.00' : StatisticUtils.checkNullAndPrettifyNumber(remainingBudget);
    },
    status() {
      return this.item.advert.budget === 0
        ? '~'
        : StatisticUtils.checkNullAndPrettifyNumber(
            this.item.advert.playedBudget * 1.0
            / this.item.advert.budget * 100.0
        ) + ' %';
    },
    tags() {
      let resultTags = '';
      let tags = this.item.advert.tags;

      for(let i =0; i < tags.length; i++) {
        resultTags += tags[i].name + ', ';
      }

      return resultTags.length > 0 ? resultTags.slice(0, -2) : '~';
    },
    budgetFinished() {
      return this.item.advertStatistic.dateBudgetFinished != null ? this.item.advertStatistic.dateBudgetFinished : '~';
    }
  }
}
</script>
